import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TenantsListPageDto } from 'app/api/models/tenant/tenantsListPageDto';
import { AuthRepository } from 'app/state/auth.repository';
import { IConfirm } from 'app/state/tenants.repository';

@Component({
  selector: 'app-tenant-list',
  templateUrl: './tenant-list.component.html',
  styleUrls: ['./tenant-list.component.scss'],
  standalone: false,
})
export class TenantListComponent implements OnInit {
  @Input() innerWidth = 0;
  @Input() set tenants(items: TenantsListPageDto[]) {
    this.originalTenants = items;
    const ids = this.getPinnedIds();
    this.originalTenants.forEach((t) => {
      if (t.id) t.pinned = ids.has(t.id);
    });
    this.applyFilters();
  }
  @Input() isDeleteDisabled = true;
  @Output() delete = new EventEmitter<string>();
  @Output() clone = new EventEmitter<IConfirm>();
  deleteConfirmation: TenantsListPageDto | null = null;
  cloneConfirmation: TenantsListPageDto | null = null;
  initTenants: TenantsListPageDto[] = [];
  originalTenants: TenantsListPageDto[] = [];
  descriptions: any[] = [];

  @Input() viewMode: 'list' | 'card' = 'list';
  filterGroup = 'allTenants';
  sortField: 'name' | 'created' | null = null;
  sortDirection: 'asc' | 'desc' = 'asc';

  private readonly PINNED_KEY = 'pinnedTenants';

  constructor(public auth: AuthRepository) {}

  ngOnInit(): void {
    this.restorePinned();
  }

  private getPinnedIds(): Set<string> {
    const raw = localStorage.getItem(this.PINNED_KEY);
    return raw ? new Set(JSON.parse(raw)) : new Set();
  }

  private savePinnedIds(ids: Set<string>): void {
    localStorage.setItem(this.PINNED_KEY, JSON.stringify([...ids]));
  }

  private restorePinned(): void {
    const ids = this.getPinnedIds();
    this.originalTenants.forEach((t) => {
      if (t.id) t.pinned = ids.has(t.id);
    });
    this.applyFilters();
  }

  handleDeleteClick(tenant: TenantsListPageDto) {
    if (!this.isDeleteDisabled) {
      this.delete.emit(tenant.id);
    }
  }

  getInitials(name: string): string {
    return name
      .split(' ')
      .slice(0, 2)
      .map((word) => word[0].toUpperCase())
      .join('');
  }

  onPin(tenant: TenantsListPageDto) {
    tenant.pinned = !tenant.pinned;
    const ids = this.getPinnedIds();
    if (tenant.pinned && tenant.id) {
      ids.add(tenant.id);
    } else if (tenant.id) {
      ids.delete(tenant.id);
    }
    this.savePinnedIds(ids);
    this.applyFilters();
  }

  onSort(field: 'name' | 'created') {
    if (this.sortField === field) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortField = field;
      this.sortDirection = 'asc';
    }
    this.applyFilters();
  }

  applyFilters() {
    const pinned = this.originalTenants.filter((t) => t.pinned);
    const unpinned = this.originalTenants.filter((t) => !t.pinned);
    const sorted = [...pinned, ...unpinned];

    if (this.sortField) {
      sorted.sort((a, b) => {
        const valA = this.sortField === 'name' ? a.name : a.createdAt;
        const valB = this.sortField === 'name' ? b.name : b.createdAt;

        if (valA < valB) return this.sortDirection === 'asc' ? -1 : 1;
        if (valA > valB) return this.sortDirection === 'asc' ? 1 : -1;
        return 0;
      });
    }

    this.initTenants = sorted;
  }

  formatText(text: string): string {
    return text.toLowerCase().replace(/\s+/g, '-');
  }
}
